import { isNil, isEmpty } from 'ramda';

export const emptyValueToDash = (value) => {
  if (isNil(value) || isEmpty(value)) {
    return '--';
  }
  return value;
};

export const emptyValueToEmptyString = (value) => {
  if (isNil(value) || isEmpty(value)) {
    return '';
  }
  return value;
};
